module.exports = __webpack_public_path__ + "img/edit.a5f061d0.svg";